import { StoryvineRestClient } from 'lib/api/rest';
import { useRef } from 'react';

export const useRestClient = () => {
  const clientRef = useRef<StoryvineRestClient>(new StoryvineRestClient());

  return [clientRef.current];
};
